import Checkbox from './Checkbox'
import GroupSingle from './GroupSingle'

export default Object.assign(Checkbox, {
  GroupSingle,
})
